import { parse, format } from 'url'
import punycode from 'punycode'
const IDNA_PREFIX = 'xn--'

export const decodeIDNA = (domain) => {
  return domain
    .split('.')
    .map(part => part.indexOf(IDNA_PREFIX) === 0 ? punycode.decode(part.slice(IDNA_PREFIX.length)) : part)
    .join('.')
}

export const getHostname = (url) => {
  const parser = document.createElement('a')
  parser.href = url
  return parser.hostname
}

export const trim = (text, len) => {
  const cut = text.indexOf(' ', len)

  if (cut === -1) {
    return text
  }

  return text.substring(0, cut) + (text.length > len ? '…' : '')
}

export const resizeImageUrl = (url, width, height) => {
  if (process.env.NODE_ENV === 'development') return url
  
  if (!url || typeof url !== 'string') return url
  const parts = parse(url)
  const pathname = parts.pathname

  // If the path contains 'cdn-cgi', '.gif', or 'width=' then skip processing
  //if (pathname.includes('cdn-cgi') || pathname.includes('.gif') || pathname.includes('width=')) {
  //  return url
  //}

  // If the URL contains either 'm3.gab.com' or 'b-cdn', add the width and height params as query values on the url.
  if (url.includes('m3.gab.com') || url.includes('b-cdn')) {
    parts.searchParams.set('width', width)
    return format(parts)
  }

  // Otherwise, update the pathname to include the Cloudflare resize parameters
  //parts.pathname = `/cdn-cgi/image/width=${width},quality=100,fit=scale-down${pathname}`
  return url // format(parts)
}
